import { MeteoSources, MeteoProviders } from 'modules/meteo/consts';
import { RoutingType } from '../consts';
import { formatIsoUtcTime } from './time';

export const formatModelName = (
  model: string,
  type: RoutingType | string,
): string => {
  if (!model) return '';
  if (type === RoutingType.eps) {
    return model.toLowerCase() === MeteoSources.ECMWF
      ? 'ECMWF Ensemble'
      : 'GFS Ensemble';
  }
  return model.toLowerCase() === MeteoSources.ECMWF ? 'ECMWF' : 'GFS';
};

// Derives the display name from a downloaded routing's internalData type.
// Type is `(ecmwf|ncep)-(fc|eps)`, or `ecmwf-aifs-(fc|eps)` for ECMWF AI.
export const formatInternalModelName = (type: string): string => {
  if (!type) return '';
  const parts = type.toLowerCase().split('-');
  if (parts.includes('aifs')) {
    return 'ECMWF AI';
  }
  if (parts[0] === MeteoProviders.ECMWF) {
    return 'ECMWF';
  }
  if (parts[0] === MeteoProviders.NCEP) {
    return 'GFS';
  }
  return '';
};

export const formatRoutingV2Subtitle = (
  model: string,
  gribType: string,
  polarSpread: boolean,
  startTime: string,
): string => {
  const formattedStartTime = formatIsoUtcTime(startTime);
  const formattedPolarSpread = polarSpread ? ' + polar spread' : '';
  const formattedGribType = gribType ? ` · ${gribType}` : '';
  return `${model}${formattedGribType}${formattedPolarSpread}, ${formattedStartTime}`;
};

export const formatRoutingSubtitle = (
  model: string,
  type: RoutingType | string,
  polar: number,
  polarSpread: boolean,
  distance: number,
  startTime: string,
): string => {
  const modelName = formatModelName(model, type);
  const formattedPolarSpread = polar ? `, Polar ${polar}%` : '';
  const formatedDistance = distance ? `, ${distance.toFixed(0)} Nm` : '';
  const formatedStartTime = formatIsoUtcTime(startTime);
  return `${modelName}${formattedPolarSpread}${
    polarSpread ? ' + polar spread' : ''
  }${formatedDistance}, ${formatedStartTime}`;
};
